import React from "react"
import { Link, useLocation } from "react-router-dom"
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible"
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "@/components/ui/sidebar"
import { HugeiconsIcon } from "@hugeicons/react"
import { ArrowRight01Icon } from "@hugeicons/core-free-icons"
import { useWorkspace } from "@/workspaces/WorkspaceContext"

export function NavMain({
  items,
}: {
  items: {
    title: string
    url: string
    icon: React.ReactNode
    items?: {
      title: string
      url: string
    }[]
    subContent?: React.ReactNode
    defaultOpen?: boolean
    badge?: number
    endIcon?: React.ReactNode
    tourId?: string
  }[]
}) {
  const { path } = useWorkspace()
  const { pathname } = useLocation()

  return (
    <SidebarGroup>
      <SidebarMenu>
        {items.map((item) => {
          const resolvedUrl = path(item.url)
          const isActive = pathname === resolvedUrl || pathname.startsWith(resolvedUrl + "/")

          return (
            <Collapsible key={item.title} asChild defaultOpen={item.defaultOpen ?? isActive}>
              <SidebarMenuItem>
                <SidebarMenuButton asChild isActive={isActive}>
                  <Link to={resolvedUrl} data-tour={item.tourId}>
                    {item.icon}
                    <span>{item.title}</span>
                    {item.endIcon ? <span className="text-muted-foreground">{item.endIcon}</span> : null}
                    {item.badge != null && item.badge > 0 && (
                      <span className="ml-auto flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-semibold leading-none text-primary-foreground">
                        {item.badge > 99 ? "99+" : item.badge}
                      </span>
                    )}
                  </Link>
                </SidebarMenuButton>
                {(item.items?.length || item.subContent) ? (
                  <>
                    <CollapsibleTrigger asChild>
                      <SidebarMenuAction className="data-[state=open]:rotate-90">
                        <HugeiconsIcon icon={ArrowRight01Icon} strokeWidth={2} />
                        <span className="sr-only">Toggle</span>
                      </SidebarMenuAction>
                    </CollapsibleTrigger>
                    <CollapsibleContent>
                      <SidebarMenuSub>
                        {item.subContent ?? item.items?.map((subItem) => (
                          <SidebarMenuSubItem key={subItem.title}>
                            <SidebarMenuSubButton asChild>
                              <Link to={path(subItem.url)}>
                                <span>{subItem.title}</span>
                              </Link>
                            </SidebarMenuSubButton>
                          </SidebarMenuSubItem>
                        ))}
                      </SidebarMenuSub>
                    </CollapsibleContent>
                  </>
                ) : null}
              </SidebarMenuItem>
            </Collapsible>
          )
        })}
      </SidebarMenu>
    </SidebarGroup>
  )
}
